import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { db } from '../firebase';
import '../styles/ShopView.css';

function ShopView({ ownerUserId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchItems = async () => {
      setLoading(true);
      setError(null);
      try {
        const q = query(
          collection(db, 'products'),
          where('ownerId', '==', ownerUserId),
          where('active', '==', true),
          orderBy('createdAt', 'desc')
        );
        const snap = await getDocs(q);
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setItems(list);
      } catch (e) {
        setError('Erreur lors du chargement des produits');
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    if (ownerUserId) fetchItems();
  }, [ownerUserId]);

  if (loading) return <div className="shop-loading">Chargement de la boutique…</div>;
  if (error) return <div className="shop-error">{error}</div>;

  if (!items.length) {
    return <div className="shop-empty">Aucun produit pour le moment.</div>;
  }

  return (
    <div className="shop-grid">
      {items.map((p) => (
        <div key={p.id} className="shop-card">
          {p.imageUrl && (
            <div className="shop-image-wrap">
              <img src={p.imageUrl} alt={p.title} className="shop-image" />
            </div>
          )}
          <div className="shop-info">
            <h4 className="shop-title" title={p.title}>{p.title}</h4>
            {p.description && (
              <p className="shop-desc" title={p.description}>
                {String(p.description).length > 120 ? `${String(p.description).slice(0, 117)}...` : p.description}
              </p>
            )}
            <div className="shop-meta">
              {p.price != null && (
                <span className="shop-price">{p.price} {p.currency || '€'}</span>
              )}
            </div>
            {p.link && (
              <a className="shop-buy" href={p.link} target="_blank" rel="noopener noreferrer">
                Acheter
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ShopView;
